import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 198 199"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "38.1487",
                height: "198",
                rx: "19.0743",
                fill: "#3B0699"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "56.8083",
                y: "85.8345",
                width: "38.1487",
                height: "38.1487",
                rx: "19.0743",
                fill: "#E3317D"
            }),
            /*#__PURE__*/ _jsx("rect", {
                y: "38.1487",
                width: "38.1487",
                height: "132.484",
                rx: "19.0743",
                transform: "rotate(-90 0 38.1487)",
                fill: "#3B0699"
            })
        ]
    }));
};
export default Icon;
